// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"48c840dd","389":"9689ef48","732":"40086b3a","970":"48a62811","977":"dab3e616"}[chunkId] + ".chunk.js";
};